import type { TOC } from '@ember/component/template-only'
import { WalkMe } from 'teacher-ui-client/components/walk-me'
import { InteractivePreview } from 'teacher-ui-client/components/interactive-preview'
import { FlashQueue } from 'teacher-ui-client/components/flash-queue'
import { MirageScenario } from 'teacher-ui-client/components/mirage-scenario'
import { ContentfulSelect } from 'teacher-ui-client/components/contentful-select'
import { DialogContainer } from 'teacher-ui-client/components/dialog'
import RouteTemplate from 'ember-route-template'
import { ZoomWebChat } from 'teacher-ui-client/components/zoom-web-chat'

export const ApplicationPage: TOC<unknown> = <template>
  <WalkMe />
  <ZoomWebChat />

  <div id="overflow-outlet" class="h-screen overflow-x-hidden overflow-y-auto bg-white print:overflow-visible">
    {{outlet}}
  </div>

  <DialogContainer />
  <InteractivePreview />

  <FlashQueue class="fixed top-24 right-4" />

  <div class="fixed bottom-0 left-0 z-50 opacity-50 hover:opacity-100 print:hidden">
    <MirageScenario class="border border-black bg-white p-2" />
    <ContentfulSelect class="border border-black bg-white p-2" />
  </div>
</template>

export default RouteTemplate(ApplicationPage)
